import { useEffect, useState } from "react";

export default function LegalLayout({ eyebrow, title, effective, updated, sections, children }) {
  const [active, setActive] = useState(sections[0]?.id);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(e.target.id);
        });
      },
      { rootMargin: "-30% 0px -60% 0px" }
    );
    sections.forEach((s) => {
      const el = document.getElementById(s.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [sections]);

  return (
    <div className="bg-[#F8FAFC] pt-[72px]" data-testid="legal-page">
      <div className="border-b border-slate-200 bg-[#0A192F]">
        <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 sm:py-20">
          <p className="font-mono-label text-[11px] uppercase tracking-[0.3em] text-[#25A5B7]">{eyebrow}</p>
          <h1 className="mt-4 text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl" data-testid="legal-title">
            {title}
          </h1>
          <div className="mt-5 flex flex-wrap gap-x-6 gap-y-1 text-xs text-slate-400">
            <span>Effective Date: {effective}</span>
            <span>Last Updated: {updated}</span>
          </div>
        </div>
      </div>

      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-14 sm:px-8 lg:grid-cols-[240px_1fr] lg:py-20">
        <aside className="hidden lg:block">
          <nav className="sticky top-28 flex flex-col gap-1" aria-label="Table of contents" data-testid="legal-toc">
            {sections.map((s, i) => (
              <a
                key={s.id}
                href={`#${s.id}`}
                data-testid={`toc-link-${s.id}`}
                className={`rounded-lg px-3 py-2 text-[13px] font-medium transition-colors ${
                  active === s.id
                    ? "bg-[#E6F4F1] text-[#0B4B52]"
                    : "text-slate-500 hover:bg-slate-100 hover:text-[#0A192F]"
                }`}
              >
                <span className="font-mono-label mr-2 text-[10px] text-[#1D8A99]">{String(i + 1).padStart(2, "0")}</span>
                {s.title}
              </a>
            ))}
          </nav>
        </aside>

        <article className="legal-body max-w-3xl text-[15px] leading-relaxed text-slate-700 sm:text-base">
          {sections.map((s, i) => (
            <section key={s.id} id={s.id} className={i === 0 ? "" : "mt-12"}>
              <h2 className="mb-4 flex items-baseline gap-3 text-xl font-bold tracking-tight text-[#0A192F] sm:text-2xl">
                <span className="font-mono-label text-xs font-medium text-[#1D8A99]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                {s.title}
              </h2>
              {s.body}
            </section>
          ))}
          {children}
        </article>
      </div>
    </div>
  );
}
